import React from 'react';
import FlipCard from './FlipCard';

const FlipCardList = ({items, space_after}) => {
    return <div className={`flip-card-list outer-container grid sp-m-${space_after}`}>
        {!!items && items.map((item, i) => <FlipCard card={item} key={i}/>)}
    </div>
}

export default FlipCardList;